import { motion, type HTMLMotionProps } from "framer-motion";
import type { PropsWithChildren } from "react";

interface SectionRevealProps extends HTMLMotionProps<"div"> {
  delay?: number;
}

export function SectionReveal({
  children,
  delay = 0,
  className,
  ...rest
}: PropsWithChildren<SectionRevealProps>) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.68, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
